import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import TipsRules from './pages/TipsRules';
import TenantProtection from './pages/TenantProtection';
import BusinessStorage from './pages/BusinessStorage';
import HouseholdStorage from './pages/HouseholdStorage';

import SizeGuide from './pages/SizeGuide';
import FAQ from './pages/FAQ';
import MovingStorage from './pages/MovingStorage';
import RVBoatStorage from './pages/RVBoatStorage';
import NotFound from './pages/NotFound';

// Scroll position on navigation. React Router keeps the current scroll
// offset when the path changes, so a header link clicked from the bottom of
// one page opens the next one already scrolled down — a plain route change
// therefore starts at the top. Links carrying a #hash (e.g. Specials ->
// People Who Serve) do not scroll on their own, so those are aimed after
// the route has painted.
function ScrollOnNavigate() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      // 'instant', not the default: App.css sets scroll-behavior: smooth,
      // so a plain scrollTo animates the whole page back up and the new
      // route appears to hang while it does.
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      return undefined;
    }
    const id = hash.slice(1);
    // A single timed scroll lands short: images and sections above the
    // target are still laying out after a route change, so the page grows
    // underneath us. Re-aim a few times until the target is actually near
    // the top, and stop early if the reader scrolls themselves.
    let done = false;
    const stop = () => { done = true; };
    window.addEventListener('wheel', stop, { passive: true });
    window.addEventListener('touchmove', stop, { passive: true });
    const timers = [60, 250, 600, 1000, 1600].map((ms, i) =>
      setTimeout(() => {
        if (done) return;
        const el = document.getElementById(id);
        if (!el) return;
        // Do NOT stop early on a position that looks right: images
        // above the target load late and push it back down. Re-aim
        // through the whole schedule; only the reader cancels it.
        el.scrollIntoView({ behavior: i === 0 ? 'smooth' : 'auto', block: 'start' });
      }, ms)
    );
    return () => {
      done = true;
      timers.forEach(clearTimeout);
      window.removeEventListener('wheel', stop);
      window.removeEventListener('touchmove', stop);
    };
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <ScrollOnNavigate />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/size-guide" element={<SizeGuide />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contractor-storage-lewisville" element={<BusinessStorage />} />
          <Route path="/business-storage-lewisville" element={<BusinessStorage />} />
          <Route path="/household-storage-lewisville" element={<HouseholdStorage />} />
          <Route path="/tips-rules" element={<TipsRules />} />
          <Route path="/tenant-protection" element={<TenantProtection />} />
          <Route path="/moving-storage-lewisville" element={<MovingStorage />} />
          <Route path="/rv-boat-storage-lewisville" element={<RVBoatStorage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;